export const getters = {
  getList: (state) => state.list
};
